var map = {
	"./decidim/avatar-multiuser.png": 19503,
	"./decidim/brands/facebook.svg": 26703,
	"./decidim/brands/google.svg": 36118,
	"./decidim/brands/twitter-x.svg": 88351,
	"./decidim/cc-badge.png": 21573,
	"./decidim/decidim-logo.svg": 42973,
	"./decidim/default-avatar.svg": 59021,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 16851,
	"./decidim/icons.svg": 87804,
	"./decidim/pattern.png": 49119,
	"./decidim/placeholder-card-g.svg": 56644,
	"./decidim/placeholder-card-l.svg": 76383,
	"./decidim/placeholder.jpg": 91270,
	"./decidim/remixicon.symbol.svg": 25996,
	"./decidim/vendor/social-share-button/douban.svg": 13407,
	"./decidim/vendor/social-share-button/email.svg": 61992,
	"./decidim/vendor/social-share-button/facebook.svg": 34804,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 13184,
	"./decidim/vendor/social-share-button/hacker_news.svg": 61708,
	"./decidim/vendor/social-share-button/linkedin.svg": 89710,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 37671,
	"./decidim/vendor/social-share-button/pinterest.svg": 23622,
	"./decidim/vendor/social-share-button/reddit.svg": 47228,
	"./decidim/vendor/social-share-button/telegram.svg": 72433,
	"./decidim/vendor/social-share-button/tumblr.svg": 75150,
	"./decidim/vendor/social-share-button/twitter.svg": 53957,
	"./decidim/vendor/social-share-button/vkontakte.svg": 93719,
	"./decidim/vendor/social-share-button/wechat.svg": 91298,
	"./decidim/vendor/social-share-button/whatsapp.svg": 80962,
	"./decidim/vendor/social-share-button/x.svg": 54088,
	"./decidim/vendor/social-share-button/xing.svg": 30816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88792;